/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Personal_DescriptionInputs */

const he_profile_personal_description = /** @type {(inputs: Profile_Personal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עדכנו את הפרטים האישיים שלכם.`)
};

const en_profile_personal_description = /** @type {(inputs: Profile_Personal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update your personal details.`)
};

/**
* | output |
* | --- |
* | "Update your personal details." |
*
* @param {Profile_Personal_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const profile_personal_description = /** @type {((inputs?: Profile_Personal_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Personal_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_profile_personal_description(inputs)
	return en_profile_personal_description(inputs)
});